<template>
  <div>
    <h5>{{ $t("caisse.modifierCaisse") }}</h5>
    <a-form :form="editForm" @submit.prevent="onEditCaisse">
      <a-row :gutter="16">
        <a-col :span="24">
          <span
            >{{ $t("caisse.statut") }}:
            <a-tag :color="caisse.status === 'active' ? 'green' : 'red'">
              {{
                caisse.status === "active"
                  ? $t("caisse.actif").toUpperCase()
                  : $t("caisse.inactif").toUpperCase()
              }}
            </a-tag></span
          >
          <span class="ml-4">
            {{ $t("caisse.type") }}:
            <a-tag>
              {{ $t(`caisse.${caisse.type}`) }}
            </a-tag>
          </span>
        </a-col>
        <a-col :span="12">
          <a-form-item :label="$t('caisse.nom')">
            <a-input
              v-decorator="[
                'name',
                {
                  initialValue: caisse.name,
                  rules: [{ required: true, message: $t('caisse.nomRequis') }],
                },
              ]"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label="$t('caisse.reference')">
            <a-input
              v-decorator="[
                'reference',
                {
                  initialValue: caisse.reference,
                  rules: [
                    { required: true, message: $t('caisse.referenceRequise') },
                  ],
                },
              ]"
            />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="12" v-if="caisse.type === 'BANK'">
          <a-form-item :label="$t('caisse.banque')">
            <BankSelect
              :value="caisse.bank"
              :placeholder="$t('caisse.nomBanque')"
              size="small"
              @change="(value) => handleBankChange(value)"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12" v-if="caisse.type !== 'BANK'">
          <a-form-item :label="$t('caisse.disponibilite')">
            <a-select
              v-decorator="[
                'availability',
                { initialValue: caisse.availability },
              ]"
            >
              <a-select-option value="OPEN">{{
                $t("caisse.ouverte").toUpperCase()
              }}</a-select-option>
              <a-select-option value="CLOSED">{{
                $t("caisse.fermee").toUpperCase()
              }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>

      <a-button type="primary" htmlType="submit" :loading="editLoading">{{
        $t("caisse.enregistrer")
      }}</a-button>
      <a-button
        v-if="caisse.status === 'active'"
        type="danger"
        class="ml-2"
        @click="onDeactivateCaisse"
        :loading="editLoading"
        >{{ $t("caisse.desactiver") }}</a-button
      >
      <a-button
        v-if="caisse.status === 'inactive'"
        type="primary"
        class="ml-2"
        @click="onActivateCaisse"
        :loading="editLoading"
        >{{ $t("caisse.activer") }}</a-button
      >
    </a-form>
  </div>
</template>

<script>
import apiClient from "@/services/axios";
import BankSelect from "@/components/BankSelect.vue";

export default {
  props: ["caisse"],
  data() {
    return {
      editForm: this.$form.createForm(this),
      editLoading: false,
    };
  },
  components: {
    BankSelect,
  },
  methods: {
    onTypeChange() {
      this.$forceUpdate();
    },
    handleBankChange(value) {
      this.caisse.bank = value;
    },
    onEditCaisse() {
      this.editForm.validateFields(async (err, values) => {
        if (!err) {
          this.editLoading = true;
          try {
            if (this.caisse.type === "BANK") {
              values.bank = this.caisse.bank;
            }
            await apiClient.patch(`/compV3/caisse/${this.caisse._id}`, values);
            this.$message.success(this.$t("caisse.caisseModifieeSucces"));
            this.$emit("updated");
          } catch (e) {
            this.$message.error(this.$t("caisse.erreurModificationCaisse"));
          } finally {
            this.editLoading = false;
          }
        }
      });
    },
    async onDeactivateCaisse() {
      this.editLoading = true;
      try {
        await apiClient.patch(`/compV3/caisse/${this.caisse._id}`, {
          status: "inactive",
        });
        this.$message.success(this.$t("caisse.caisseDesactiveeSucces"));
        this.$emit("updated");
      } catch (e) {
        this.$message.error(this.$t("caisse.erreurDesactivationCaisse"));
      } finally {
        this.editLoading = false;
      }
    },
    async onActivateCaisse() {
      this.editLoading = true;
      try {
        await apiClient.patch(`/compV3/caisse/${this.caisse._id}`, {
          status: "active",
        });
        this.$message.success(this.$t("caisse.caisseActiveeSucces"));
        this.$emit("updated");
      } catch (e) {
        this.$message.error(this.$t("caisse.erreurActivationCaisse"));
      } finally {
        this.editLoading = false;
      }
    },
  },
};
</script>
